import './ErrorMessage.scss';
import { Icon } from '../icon/Icon';
interface FeedbackMessageProps {
  /**
   * Set the type of feedback message
   */
  type: 'error' | 'success';
  /**
   * Set the text to display
   */
}

export const ErrorMessage = ({
  type,
  ...props
}: FeedbackMessageProps) => {
  const iconName = type === 'error' ? 'Error' : 'Success';
  return (
    <>
      <div className={`feedback feedback--${type}`} {...props}>
        <Icon iconName={iconName} svgProps={{ size: 58 }} />
      </div>
    </>
  );
};


export default ErrorMessage

